(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations-cart"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

    
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations-cart');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              let event = new Event("recommendations-cart-loaded", {bubbles: true});
              document.body.dispatchEvent(event);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
    }
  }

  customElements.define('product-recommendations-cart', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
